import { render, staticRenderFns } from "./PasswordModification.vue?vue&type=template&id=6aacab1a&scoped=true&"
import script from "./PasswordModification.ts?vue&type=script&lang=ts&"
export * from "./PasswordModification.ts?vue&type=script&lang=ts&"
import style0 from "./PasswordModification.scss?vue&type=style&index=0&id=6aacab1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aacab1a",
  null
  
)

export default component.exports